<lms-breadcrumb></lms-breadcrumb>
<div class="gl-dashboard__toolbar">
  <div
    *ngIf="clients?.length > 1"
    class="gl-dashboard__selector"
    tabindex="-1"
    (focusout)="showClientsSelector = false"
  >
    <!-- Client filters -->
    <div class="gl-select">
      <div
        class="gl-select-item"
        [ngClass]="{ open: showClientsSelector }"
        (click)="showClientsSelector = !showClientsSelector"
      >
        <div class="gl-selected-item" [ngClass]="{ placeholder: !selectedClientsIds.size }">
          {{ selectedClientsNames }}
        </div>
        <span class="glicon-down"></span>
      </div>
    </div>
    <div [ngClass]="{ 'display-none': !showClientsSelector }">
      <div class="gl-dropdown open">
        <div class="gl-dropdown__option separator">
          <gl-checkbox
            *ngIf="allClientsSelected !== 'any'"
            small
            [checked]="allClientsSelected === 'all'"
            [label]="'actions.selectAll' | translate"
            (onChange)="toggleSelectAll($event.detail.value)"
          ></gl-checkbox>
          <gl-checkbox
            *ngIf="allClientsSelected === 'any'"
            small
            indeterminate
            [label]="'actions.selectAll' | translate"
            (onChange)="toggleSelectAll(false)"
          ></gl-checkbox>
        </div>
        <div *ngFor="let client of clients" class="gl-dropdown__option">
          <gl-checkbox
            small
            [checked]="selectedClientsIds.has(client.id)"
            [label]="client.name"
            (onChange)="selectClient($event.detail.value, client.id)"
          ></gl-checkbox>
        </div>
      </div>
    </div>
    <!-- End client filters -->
  </div>
  <div
    *ngIf="dashboardData?.metadata"
    class="gl-dashboard__lastModified"
    [ngClass]="{ 'margin-top': clients?.length > 1 }"
  >
    <span
      >{{ 'reports.lastDataUpdate' | translate }} <b>{{ dashboardData.metadata.lastUpdate | date : 'shortDate' }}</b>
      {{ dashboardData.metadata.lastUpdate | date : 'HH:mm' }}</span
    >
    <gl-tooltip posbottom [text]="'reports.lastDataUpdateMessage' | translate"></gl-tooltip>
  </div>
</div>
<div
  *ngIf="dashboardWidgets"
  [ngClass]="dashboardWidgets['dashboardType'] === 'old' ? 'dashboard-widget-container' : 'gl-dashboard'"
>
  <lms-widget-container
    class="{{ widget['data']['class'] }}"
    *ngFor="let widget of dashboardWidgets['widgets']"
    [widget]="widget"
  ></lms-widget-container>
</div>
